// extracted by mini-css-extract-plugin
export default {"main":"JobOffer_main__NR5Et","ltr":"JobOffer_ltr__+k8Bg","rtl":"JobOffer_rtl__KZfKC","first":"JobOffer_first__usukp","firstPara":"JobOffer_firstPara__r5Qnt"};